import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '@env/environment';
import {
  ICreateSettlement2Info,
  IInitialSettlementInfo,
  IUploadSettlementFile,
} from '@core/interfaces/settlement.Interface';
import { ResponseData } from '@core/types/types';
import { IUploadClaimFileResponse } from '@core/interfaces/claim.Interface';

@Injectable({
  providedIn: 'root',
})
export class SettlementService {
  private readonly apiUrl = environment.apiUrl;

  private readonly _settlement = signal<IInitialSettlementInfo | undefined>(undefined);
  private readonly _createSettlementInfo = signal<ICreateSettlement2Info>({});
  private readonly _initialSettlementInfo = signal<IInitialSettlementInfo | undefined>(
    undefined
  );

  settlement = this._settlement.asReadonly();
  initialSettlementInfo = this._initialSettlementInfo.asReadonly();
  createSettlementInfo = this._createSettlementInfo.asReadonly();

  constructor(private readonly http: HttpClient) {}

  createSettlement(
    token: string
  ): Observable<ResponseData<{ solicitudRadicacionId: number }>> {
    
    return this.http.post(
      `${this.apiUrl}/api/v1/radicar`,
      this.createSettlementInfo(),
      {
        headers: { token: token },
      }
    ) as Observable<ResponseData<{ solicitudRadicacionId: number }>>;
  }

  setInitialSettlementInfo(InitialSettlementInfo: IInitialSettlementInfo) {
    sessionStorage.setItem(
      'initialSettlementInfo',
      JSON.stringify(InitialSettlementInfo)
    );
    this._initialSettlementInfo.update((value) => ({
      ...value,
      ...InitialSettlementInfo,
    }));
  }

  getInitialSettlementInfo(
    payloadId?: string
  ): Observable<ResponseData<IInitialSettlementInfo>> {
    if (sessionStorage.getItem('initialSettlementInfo')) {
      return of({
        data: JSON.parse(sessionStorage.getItem('initialSettlementInfo')!),
      } as ResponseData<IInitialSettlementInfo>);
    } else {
      return this.http.get(
        `${this.apiUrl}/radicacion/buscar-info-proceso/${payloadId}`
      ) as Observable<ResponseData<IInitialSettlementInfo>>;
    }
  }

  getInitialSettlementInfo2(
    payloadId?: string
  ): Observable<ResponseData<IInitialSettlementInfo>> {
    return this.http.get(
      `${this.apiUrl}/radicacion/buscar-info-proceso/${payloadId}`
    ) as Observable<ResponseData<IInitialSettlementInfo>>;
  }

  updateCreateSettlementInfo(data: ICreateSettlement2Info) {
    this._createSettlementInfo.update((info) => ({ ...info, ...data }));
  }

  getCreatedSettlementInfo(
    settlementRequestId: number,
    token: string
  ): Observable<ResponseData<any>> {
    return this.http.get(
      `${this.apiUrl}/radicacion/consultar/${settlementRequestId}`,
      {
        headers: { token: token },
      }
    ) as Observable<ResponseData<any>>;
  }

  setSettlement(settlement: IInitialSettlementInfo) {
    this._settlement.update((value) => ({ ...value, ...settlement }));
  }

  uploadClaimFiles(
    claimFiles: {
      claimId: string;
      payloadId: string;
      files: IUploadSettlementFile[];
    },
    token: string
  ): Observable<ResponseData<IUploadClaimFileResponse>> {
    return this.http.post(
      `${this.apiUrl}/api/v1/adjuntar-documento-radicacion`,
      claimFiles,
      {
        headers: { token: token },
      }
    ) as Observable<ResponseData<IUploadClaimFileResponse>>;
  }
}
